export { default } from './EzMaskInput.vue';
